import type { CreateModalView } from './useCreateModalController';

/** Step 2 titles, by registry id. One place, so every entry point agrees. */
export const DETAILS_TITLE: Readonly<Record<string, string>> = {
  collection: 'New collection',
  import: 'Import files',
  protocol: 'New protocol',
  spreadsheet: 'New spreadsheet',
  equipment: 'Add equipment',
  link: 'New link',
  phone: 'Bower on your phone',
  photo: 'Photo → text',
};

/**
 * "{verb} {destination}" under a step 2 title. Not for New collection: its
 * own "Inside" chip already says where it goes.
 */
export const DETAILS_VERB: Readonly<Record<string, string>> = {
  import: 'Importing into',
  protocol: 'Saving to',
  spreadsheet: 'Saving to',
  equipment: 'Adding to',
  link: 'Adding to',
  photo: 'Saving to',
};

export function viewTitle(view: CreateModalView): string {
  switch (view.kind) {
    case 'choose':
      return 'What would you like to create?';
    case 'details':
      return DETAILS_TITLE[view.type] ?? 'Create';
    case 'picker':
      return 'Save to…';
  }
}
